/**
 * The landing page's showcase: one to three images and a caption, shown side by side in one frame (stacked on a
 * phone). To show another building, put its images in ./showcase/ and change this file only; the layout follows
 * the images' width and height.
 *
 * Never client work without the owner's and the client's word. Now: the kit's made-up example model ("Dæmihús"),
 * captured from the web viewer (cutaway of the ground floor; plan with dimensions).
 */
import cutaway from './showcase/daemihus-cutaway.webp';
import plan from './showcase/daemihus-plan.webp';

export interface ShowcaseImage {
  src: string;
  width: number;
  height: number;
  alt: { is: string; en: string };
}

export interface Showcase {
  images: ShowcaseImage[];
  caption: { is: string; en: string };
}

export const showcase: Showcase = {
  images: [
    {
      src: cutaway,
      width: 1600,
      height: 1000,
      alt: {
        is: 'Líkan af tilbúnu parhúsi í vefskoðaranum: jarðhæðin skorin, með veggjum, hurðum, gluggum og stigum.',
        en: 'A made-up pair of houses in the web viewer: the ground floor cut away, with walls, doors, windows and stairs.',
      },
    },
    {
      src: plan,
      width: 1200,
      height: 900,
      alt: {
        is: 'Grunnmynd jarðhæðar sama líkans með málsetningum og heitum rýma.',
        en: 'The same model’s ground-floor plan with dimensions and room names.',
      },
    },
  ],
  caption: {
    is: 'Tilbúið dæmi, ekki raunverulegt hús. Líkanið í vefskoðaranum: þrívídd og grunnmynd með málsetningum.',
    en: 'A made-up example, not a real building. The model in the web viewer: 3D and a dimensioned plan.',
  },
};
